import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ToastService } from '@ellf/app-ui-kit';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as ErrorActions from './ngrx-error.actions';

@Injectable()
export class ErrorEffects {
  constructor(
    private actions$: Actions,
    private toastService: ToastService,
  ) {}

  apiError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActions.addApiErrorMsg),
        tap((action) => {
          if (action.errorMessage) {
            this.toastService.errorFeedback(action.errorMessage);
          }
          // eslint-disable-next-line no-console
          console.error(action.errorMessage);
        }),
      ),
    { dispatch: false },
  );

  error$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActions.addError),
        tap((action) => {
          // eslint-disable-next-line no-console
          console.error('Errore imprevisto:', action.error);
        }),
      ),
    { dispatch: false },
  );
}
